module.exports = __webpack_public_path__ + "img/northstar-2.38b556cc.jpg";